import { EAccessMenu } from "@/graphql/types";
import { getPermissions } from "@/utils/activity";

export const useStockPermissions = () => {
  return getPermissions(EAccessMenu.Stock);
};
